import {AsyncJavaRequest, Main, RequestTypes} from "@/controller/main";

export class QueryFacade {
    public static async put(table: string, toPersist: IDBase): Promise<void> {
        let putQueryOperation = new PutQueryOperation(toPersist.id, table, toPersist);
        await Main.postMessage(new QueryRequest("put",putQueryOperation));
    }

    public static async get(table: string, id: string): Promise<any> {
        let getQueryOperation = new GetQueryOperation(id, table);
        return JSON.parse(await Main.postMessage(new QueryRequest("get",getQueryOperation)));
    }


}

export interface IDBase {
    id: string;
}

type QueryTypes="put"|"get";
class QueryRequest extends AsyncJavaRequest{
    public readonly queryOperation:QueryOperation;

    constructor( action: any, queryOperation: QueryOperation) {
        super("query", action);
        this.queryOperation = queryOperation;
    }
}
abstract class QueryOperation{
    public id: string | null = null;
    public readonly tableName: string;

    protected constructor(type: QueryTypes , id: string | null, tableName: string) {
        this.id = id;
        this.tableName = tableName;
    }
}

class GetQueryOperation extends QueryOperation {
    constructor(id: string, tableName: string) {
        super("get", id, tableName);
    }
}

class PutQueryOperation extends QueryOperation {
    public readonly  data: string;

    constructor(id: string | null, tableName: string, data: IDBase) {
        super("put", id, tableName);
        this.data = JSON.stringify(data);
    }
}